import script from "./featureDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./featureDialog.vue?vue&type=script&setup=true&lang=js"

import "./featureDialog.vue?vue&type=style&index=0&id=4670773c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4670773c"]])

export default __exports__